import React, { useState, useEffect } from "react";

import { RideGrid } from "@rimac-seguros/ride-system-components";
import { useDispatch, useSelector } from "react-redux";

import { useLoadInitialData } from "../../hooks/useLoadInitialData";
import { useQuote } from "../../hooks/useQuote";
import { CoverageAmount } from "./CoverageAmount";
import { SavingTime } from "./SavingTime";
import { ReturnPercentage } from "./ReturnPercentage";
import { PaymentFrequency } from "./PaymentFrequency";
import { DownloadQuote } from "./DownloadQuote";
import { CardDetailPlan } from "../../../shared/components/CardDetailPlan";
import { planSelected } from "@/redux/actions/plans";
import { StateMachine } from "@/utils/consts";
import { usePlansContext } from "../../context/PlansContext";
import { ModalError } from "@/components/molecules/ModalError";
import { setViewModalError } from "@/redux/actions/global";
import { compareSumAssured } from "@/utils/Utils";
import helpers from "@/utils/helpers";

import "./styles.scss";

const SectionPlans = ({ paymentFrequencyList, urlHome }) => {
  const detailPlanSelected = useSelector((state) => state.plans.planSelected);
  const { state } = useSelector((state) => state.global);
  const userData = useSelector((state) => state.vida.userData);
  const [isGreatterValue, setIsGreaterValue] = useState(false);
  const [showModalError, setShowModalError] = useState(false);

  const {
    arraySumAssured,
    arraySavingTime,
    arrayReturnPercentage,
    sumAssured,
    savingTime,
    returnPercentage,
    frequency,
    firstLoad,
    setSumAssured,
    setSavingTime,
    setReturnPercentage,
    setFrequency,
    resetList,
    getReturnPercentage,
  } = useLoadInitialData({ paymentFrequencyList, setShowModalError });
  const {
    loadingSumAssured,
    loadingSavingTime,
    loadingReturnPercentage,
    isLoadingData,
  } = usePlansContext();

  const { sendQuote } = useQuote({ setShowModalError });
  const dispatch = useDispatch();

  useEffect(() => {
    if (userData.indPrevPageApp) {
      helpers.sendMessageToApp("EMBEDDED-APP-SHOW-TOPBAR");
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    if (state === StateMachine[4]) {
      if (userData.indPrevPageApp) {
        helpers.sendMessageToApp("error-api");
      }
      return dispatch(setViewModalError(true));
    }
  }, [state]);

  const handleSelectSumAssured = async (item) => {
    setSumAssured(item);
    updateStore("sumAssured", item);
    setIsGreaterValue(compareSumAssured(item, sumAssured));
    await resetList(item, sumAssured);
  };

  const handleSelectSavingTime = async (item) => {
    setSavingTime(item);
    updateStore("savingTime", item);
    setIsGreaterValue(compareSumAssured(item, savingTime));
    if (!firstLoad) {
      await getReturnPercentage(item);
    }
  };

  const handleSelectReturnPercentage = async (item) => {
    setReturnPercentage(item);
    updateStore("returnPercentage", item);

    if (!firstLoad) {
      await sendQuote({
        sumAssured,
        savingTime,
        returnPercentage: item,
        frequency,
      });
    }
  };

  const handleSelectFrequency = async (item) => {
    setFrequency(item);
    updateStore("frequency", item);
  };

  const updateStore = async (key, value) => {
    dispatch(
      planSelected({
        ...detailPlanSelected,
        [key]: value,
      }),
    );
  };

  const callAnalyticsAction = () => {
    helpers.getTagAction(
      "Seguro Vida Devolución Garantizada",
      "Cotización",
      "click",
      "Ver más - B",
      "trackAction",
    );
  };

  const handleClickRedirect = () => {
    return (window.location.href = urlHome);
  };

  return (
    <>
      <RideGrid className="section-plans">
        <div className="section-plans_title">
          <h1>
            <span>Personaliza</span> tu plan
          </h1>
        </div>
        <div className="section-plans_content">
          <CoverageAmount
            list={arraySumAssured}
            disabled={isLoadingData}
            sumAssured={sumAssured}
            onSelected={handleSelectSumAssured}
          />
          <SavingTime
            list={arraySavingTime}
            defaultValue={savingTime}
            loading={loadingSavingTime}
            disabled={isLoadingData}
            onSelected={handleSelectSavingTime}
            isGreatterValue={isGreatterValue}
          />
          <ReturnPercentage
            list={arrayReturnPercentage}
            defaultValue={returnPercentage}
            loading={loadingReturnPercentage}
            disabled={isLoadingData}
            onSelected={handleSelectReturnPercentage}
            isGreatterValue={isGreatterValue}
          />
          <PaymentFrequency
            list={paymentFrequencyList}
            frequency={frequency}
            onSelected={handleSelectFrequency}
          />
          <DownloadQuote />
        </div>
        <div className="hidden lg:block lg:col-span-5 lg:col-start-8">
          <CardDetailPlan
            isLoadingData={isLoadingData}
            callAnalyticsAction={callAnalyticsAction}
          />
        </div>
      </RideGrid>
      {showModalError && (
        <ModalError
          open={showModalError}
          icon="RideFiErrorLight"
          title="Ocurrió un error"
          message="Lo sentimos, hubo un problema técnico. Un asesor te llamará para ayudarte con tu cotización."
          buttonText="Ir al inicio"
          onClose={handleClickRedirect}
        />
      )}
    </>
  );
};

export default SectionPlans;
